export default __webpack_public_path__ + "static/egp3-6f54138a4ee909cb5525d7db3f11081f.jpg";